import './Header.css'

export default {
	name: "eiis-header",
	setup(props) {
    return {} // anything returned here will be available for the rest of the component
  },
  props: {
    align: String
  },
	methods: {
		computedClasses: function() {
			return this.align;
		}
	},
	mounted () {
  },
  template: `
    <div class="eiis-header">
      <div class="eiis-header-content" v-bind:class=computedClasses>
        <slot>
        </slot>
      </div>
    </div>
  `
}